// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChangePassword_wrapper__3lyAa","warning":"ChangePassword_warning__1kkGk"};